import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { LessonAttemptState } from '../../../core/types/lesson.types';

interface ApprovalStatusBadgeProps {
    state: LessonAttemptState | undefined;
    rejectReason?: string;
}

export function ApprovalStatusBadge({ state, rejectReason }: ApprovalStatusBadgeProps) {
    const getStatusConfig = () => {
        if (state === LessonAttemptState.APPROVED) {
            return {
                icon: <CheckCircle className="w-5 h-5" />,
                text: 'Aprobat',
                variant: 'default' as const,
                containerClass: 'bg-success/10 border-success',
                textClass: 'text-success',
            };
        }

        if (state === LessonAttemptState.REJECTED && rejectReason) {
            return {
                icon: <XCircle className="w-5 h-5" />,
                text: `Respins: ${rejectReason}`,
                variant: 'destructive' as const,
                containerClass: 'bg-destructive/10 border-destructive',
                textClass: 'text-destructive',
            };
        }

        // PENDING_APPROVAL or IN_PROGRESS
        return {
            icon: <Clock className="w-5 h-5" />,
            text: 'În așteptare',
            variant: 'secondary' as const,
            containerClass: 'bg-warning/10 border-warning',
            textClass: 'text-warning-text',
        };
    };

    const status = getStatusConfig();

    return (
        <div className={`p-4 border rounded-lg ${status.containerClass}`}>
            <div className={`flex items-center gap-2 ${status.textClass}`}>
                {status.icon}
                <span className="font-semibold">{status.text}</span>
            </div>
        </div>
    );
}
